import axios from "../../../../../../api/axiosInstance";
import { IncrementProductViewCountResponse } from "./types";

export const incrementProductViewCount = async (
  id: string,
): Promise<IncrementProductViewCountResponse> => {
  const response = await axios.post<IncrementProductViewCountResponse>(
    `/api/private/product-store/products/${id}/view`,
  );
  return response.data;
};
